import styled from "styled-components";
import { ProcessorsPageStyle } from "@pages/processorsPage/processorsPageStyle";

export const CollectorsPageStyle = styled(ProcessorsPageStyle)`

`;
